import axios from '../../../axios'


// 获取列表
export const list = (data) => {
  return axios({
    url: '/workorder/woRepairVehicle/list',
    method: 'post',
    data
  })
}


// 保存信息
export const save = (data) => {
  return axios({
    url: '/workorder/woRepairVehicle/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woRepairVehicle.js